import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MapsAPILoader } from '@agm/core';
import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";

declare const $: any;

@Component({
  selector: 'app-construction-company-project',
  templateUrl: './construction-company-project.component.html',
  styleUrls: ['./construction-company-project.component.css']
})
export class ConstructionCompanyProjectComponent implements OnInit {
  slug = null;

  projectSlug = null;
  tabFilter: any = [
    {name: 'Todos', value: 'all'},
    {name: 'Vivienda VIS', value: 'VIS'},
    {name: 'Vivienda no VIS', value: 'noVIS'},
    {name: 'Sobre planos', value: 'plans'},
    {name: 'En construcción', value: 'construction'},
    {name: 'Entrega inmediata', value: 'immediately'},
  ];
  projectsRelated = [1,2,3,4,5,6,7,8]

  lat = 4.674464;
  lng = -74.052157;
  zoom: number = 15;

  version:boolean = false;

  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;


  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showImageTitle: false,
    reactToMouseWheel: true,
    showExtUrlControl: false,
    reactToRightClick: true,
    imagePointer: true
  };
  images: GALLERY_IMAGE[] = [
    {
      url: "/assets/img/constructoras/gallery-0.jpg", 
      thumbnailUrl: "/assets/img/constructoras/gallery-0.jpg"
    },
    {
      url: "/assets/img/constructoras/gallery-1.jpg", 
      thumbnailUrl: "/assets/img/constructoras/gallery-1.jpg"
    },
    {
      url: "/assets/img/constructoras/gallery-2.jpg", 
      thumbnailUrl: "/assets/img/constructoras/gallery-2.jpg"
    },
    {
      url: "/assets/img/constructoras/gallery-3.jpg", 
      thumbnailUrl: "/assets/img/constructoras/gallery-3.jpg"
    },
    {
      url: "/assets/img/constructoras/gallery-1.jpg", 
      thumbnailUrl: "/assets/img/constructoras/gallery-1.jpg"
    },
  ];
  

  constructor(
    
    protected activateRoute: ActivatedRoute,
    protected mapsAPILoader: MapsAPILoader,
    
  ) {
    this.activateRoute.params.subscribe(v => this.slug = v.slug);
    this.activateRoute.queryParams
      .subscribe(params => {
        console.log(params.v); // { orderby: "price" }
        if(params?.v == 2) {
          this.version = true;
          window.location.href = 'https://vivienda.com/constructoras/' + this.slug + '/proyecto/'+ this.projectSlug +'/v2'
        }
      }
    );
  }

  ngOnInit(): void {

    $(".collapse").click(function(event){
      event.stopPropagation();
   });

    $('.accordion .btn').on('click',function(event){
      let el = event.currentTarget;
      let validation = $(el).hasClass('collapsed');

      if (validation) {

      } else {
        setTimeout(function() {
          $(el).addClass('collapsed');
        }, 200);

        setTimeout(function() {
          $(el).next('.collapse').removeClass('show');
        }, 400);
      }

    });
    
    setTimeout(() => {
      $('.carouselrelated').owlCarousel({
        autoHeight: true,
        nav: false,
        dots: true,
        loop: true,
        margin: 15,
        items: 4,
        responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1,
          },
          768 : {
            items: 2,
          },
          1024 : {
            items: 4,
          }
      }
      });
    }, 2000);
    
  }

  // METHODS
  // open gallery
  openGallery(index: number = 0) {
    this.ngxImageGallery.open(index);
  }

  contact(f: any): void {
    if (f.form?.status == 'VALID') {
      let data = f.form.value;
      
    }
  }
  filterTabBy(e: any) {
    console.log(e);

  }

}
